import React, { useState } from 'react';
import bgimage from '../assets/images/bgimage.jpg'
import LoginHook from '../hooks/LoginHook'
export default function Login() {

    const { adminLogin, isLoading } = LoginHook()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [rememberMe, setRememberMe] = useState('')

    const submitForm = async (e) => {
        e.preventDefault()
        await adminLogin(email, password, rememberMe)
    }
    return (
        <div className='container-fluid bg-white signup_form '>

            <div className="row justify-content-center h-100 p-0">
                <div className="col-md-6 col-lg-4 d-lg-block d-none p-0">
                    <div className="bg_image">
                        <img src={bgimage} className='p-0' alt="" />

                    </div>

                </div>
                <div className="col-md-10 col-lg-4 px-md-1 px-xl-4 px-2 my-auto mx-auto p-0">
                    <form onSubmit={submitForm}>
                        <div className="mb-1">
                            <h1>Login as Admin</h1>
                            <p>Welcome back!</p>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                                </svg>
                                <input
                                    type="email" className='m-0'
                                    placeholder='Email'
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="col-md-12">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                                </svg>
                                <input
                                    type="password" className='m-0'
                                    placeholder='Password'
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>

                            <div className="col-md-12 mt-2">
                                <div className="d-flex justify-content-between px-2">
                                    <div className="left">
                                        <label htmlFor="remember_me " className='remember_me'>
                                            <input
                                                type="checkbox"
                                                className="me-2 d-inline"
                                                checked={rememberMe}
                                                onChange={(e) => setRememberMe(e.target.checked)}
                                            />
                                            Remember me
                                        </label>
                                    </div>

                                </div>
                            </div>

                        </div>


                        <button type="submit" className="btn btn-primary w-100 mt-4" disabled={isLoading}>Login</button>


                    </form>
                </div>
            </div>

        </div>
    );
}
